import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Badge,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Select from "react-select";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SnackbarComponent from "../../../components/Snackbar/Snackbar";
import SiteFooterFourShape1 from "../../../assets/images/shapes/site-footer-four-shape-1.png";
import Logo2 from "../../../assets/images/resources/logo-2.png";
import AboutDetail3 from "../../../assets/images/resources/about-detail3.jpg";
import CTAThreeBgShape from "../../../assets/images/shapes/cta-three-bg-shape.png";
import { backendUrl } from "../../../constants/config";
import { Backdrop, Box, CircularProgress, Grid, Menu, Drawer, List, Divider, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import MenuDrawer from "../../../components/MenuDrawer/MenuDrawer";
import AppBar from "../../../components/AppBar/AppBar";
import TitleWithSearchBar from "../../../components/TitleWithSearchBar/TitleWithSearchBar";
import TitleWithoutSearchBar from "../../../components/TitleWithoutSearchBar/TitleWithoutSearchBar";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { GoogleLogin } from "@react-oauth/google";
import PricingOneShape2 from "../../../assets/images/shapes/pricing-one-shape-2.png";
import PricingOneShape3 from "../../../assets/images/shapes/pricing-one-shape-3.png";
import PricingOneShape4 from "../../../assets/images/shapes/pricing-one-shape-4.png";
import PricingOneShape1 from "../../../assets/images/shapes/pricing-one-shape-1.png";
import PricingOneIcon2 from "../../../assets/images/icon/pricing-one-icon-2.png";
import CTAThreeBgShape2 from "../../../assets/images/shapes/cta-three-bg-shape-2.png";
import jwtDecode from "jwt-decode";
import TalentSyncLogo from "../../../assets/images/talentSync_Logo.png";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import "./payment.css";


const Payment = () => {
  
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const DrawerList = (
    <Box
      sx={{ width: 250, backgroundColor: "#040b1e", color: "white" }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <div
        style={{
          display: "flex ",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "fit-content",
        }}
      >
        <img src={TalentSyncLogo} style={{ width: "15%" }} alt="logo"></img>
        <span
          className="mobile-nav__close mobile-nav__toggler"
          style={{ marginTop: "5%" }}
        >
          <i className="fa fa-times" onClick={toggleDrawer(false)}></i>
        </span>
      </div>
      <List>
        {/* Navigation Items */}
        <ListItem button component="a" href="/">
          <ListItemText
            primary="Home"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/about">
          <ListItemText
            primary="About"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/pricing">
          <ListItemText
            primary="Pricing"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/how-it-works">
          <ListItemText
            primary="How It Works"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/contact">
          <ListItemText
            primary="Contact"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
      </List>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "20px",
          marginTop: "8%",
        }}
      >
        <a href="#" className="fab fa-twitter" style={{ color: "white" }}></a>
        <a
          href="#"
          className="fab fa-facebook-square"
          style={{ color: "white" }}
        ></a>
        <a
          href="#"
          className="fab fa-pinterest-p"
          style={{ color: "white" }}
        ></a>
        <a href="#" className="fab fa-instagram" style={{ color: "white" }}></a>
      </div>
    </Box>
  );
  const navigate = useNavigate();
  const [err, setErr] = useState(null);
  const [user, setUser] = useState(null);
  const [success, setSuccess] = useState(null);

  const [paymentStatus, setPaymentStatus] = useState("");

  useEffect(() => {
    const talentSyncUser = JSON.parse(localStorage.getItem("TalentSyncUser"));
    if (talentSyncUser) {
      setUser(talentSyncUser);
    }
  }, []);

  const handleSubscription = async () => {
    try {
      const response = await axios.put(`${backendUrl}/user/updateUser`, {
        id: user?.id,
        user: {
          subscriptionBought: true,
        },
      });
      setSuccess("Processing your payment...");

      localStorage.setItem(
        "TalentSyncUser",
        JSON.stringify(response.data.updatedUser)
      );

      setTimeout(() => {
        setPaymentStatus("Payment successful! Thank you for your purchase.");
        navigate("/profile-form"); // Navigate after the timeout
      }, 2000);
    } catch (err) {
      console.log(err);
      setErr("Error Subscribing to plan.");
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [state, setState] = React.useState({
    left: false,
  });
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    seterror(false);
  };
  const [error, seterror] = useState(false);
  const [errorMsg, seterrorMsg] = useState("");

  return (
    <Box style={{ backgroundColor: "#f7f8fa", display: "flex", flex: 1 }}>
      <MenuDrawer admin toggleDrawer={toggleDrawer} state={state} />
      
      {/* <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop> */}
      <SnackbarComponent
        err={err}
        success={success}
        setErr={setErr}
        setSuccess={setSuccess}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          overflow: "hidden",
        }}
      >
        <AppBar title="Payment Page" toggleDrawer={toggleDrawer} />
        
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        ></Menu>

        <Grid container p={2}>
          <Grid item xs={12} md={12}>
            <Box
              mb={2}
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
              }}
            >
              {/* <TitleWithoutSearchBar title="Profile" halfWidth /> */}

              <section
                className=""
                style={{
                  position: "relative",
                  display: "block",
                  zIndex: "1",
                }}
              >
                <div
                  className="container"
                  style={{ paddingTop: "10px", paddingBottom: "10px" }}
                >

                  <div className="content-container">
                    <h5>Built on trust and honor:</h5>

                    <h5>Settle your payment here after securing employment through us. Thank you</h5>

                    <div className="pricing-one__btn-box">
                     {/* {user && (*/}
                        <PayPalButtons
                          style={{
                            color: "blue",
                            label: "paypal",
                            tagline: false,
                            height: 50,
                          }}
                          createOrder={(data, actions) => {
                            return actions.order.create({
                              purchase_units: [
                                {
                                  amount: {
                                    currency_code: "USD",
                                    value: 300,
                                  },
                                },
                              ],
                              application_context: {
                                shipping_preference: "NO_SHIPPING",
                              },
                            });
                          }}
                          onApprove={async (data, actions) => {
                            return actions.order.capture().then(async function (details) {
                              handleSubscription();
                            });
                          }}
                          onCancel={(data) => {
                            setPaymentStatus("Payment was cancelled. Please try again.");
                            setErr("Payment was cancelled. Please try again.");
                            console.log("Payment cancelled", data);
                          }}
                          onError={(err) => {
                            setPaymentStatus(`Error occurred: ${err.message}`);
                            setErr("An error occurred while performing the transaction.");
                            console.log("Error", err);
                          }}
                        />
                    {/*  )}*/}
                    </div>
                  </div>
                </div>
              </section>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Payment;
